;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import { DropdownMenuSeparator } from "@/components/ui/dropdown-menu"

export default function Divider() {
  return <DropdownMenuSeparator className="mx-0 my-1 h-px bg-[rgba(0,0,0,0.12)]" />
}
